import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-emea/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Synopsis</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources & Presentations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Deliverables</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Goals</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Guardrails</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Scoring Criteria</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Supporting Assets</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Synopsis`}</h2>
    <ul>
      <li parentName="ul">{`Working in teams of five (5), `}<strong parentName="li">{`evaluate a set of client requirements`}</strong>{`, problem statements, goals/outcomes (PoC simulation) to `}<strong parentName="li">{`create a recommended CP4i & integration component configurations`}</strong>{`.`}</li>
      <li parentName="ul">{`Develop documentation that reflects your recommendations and captures `}<strong parentName="li">{`key assumptions`}</strong>{` and key `}<strong parentName="li">{`design decisions`}</strong>{`.`}</li>
      <li parentName="ul">{`Calculate the cluster(s) `}<strong parentName="li">{`sizing requirements`}</strong>{` and CP4i licensing `}<strong parentName="li">{`entitlement estimates`}</strong>{`.`}</li>
      <li parentName="ul">{`Prepare specific technical recommendations that counter a competitive PoC scenario `}<strong parentName="li">{`against MuleSoft`}</strong>{`.`}</li>
      <li parentName="ul">{`Each team will be evaluated on the following `}<a href="https://ibm.ent.box.com/file/969024649659" target="_blank">{`Scorecard criteria`}</a>{`. `}<strong parentName="li">{`A passing grade is 75%.`}</strong></li>
    </ul>
    <hr></hr>
    <h2>{`Resources & Presentations`}</h2>
    <ul>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/uken0xfa1i7n1i7cutroc1efp4k7x642" target="_blank">Session Overview Presentation</a>
      </li>
    </ul>
    <hr></hr>
    <h2>{`Deliverables`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create key `}<a href="https://ibm.box.com/s/kjgq175mvpr36bigr1u3u0g1558mrr43">{`Architecture Diagrams`}</a>{` that Illustrate the core elements of the proposed solution. This could include any of the following work product types (these are suggestions only).`}</p>
        <ol parentName="li">
          <li parentName="ol">{`Architecture Overview Diagram(s)`}</li>
          <li parentName="ol">{`Network Diagrams`}</li>
          <li parentName="ol">{`Topology Diagrams`}</li>
          <li parentName="ol">{`System Context Diagram`}</li>
        </ol>
      </li>
      <li parentName="ol">
        <a href="https://ibm.box.com/s/5kz0q0e33hfrlr5s9rgxlne6ixnbgd1u">Architecture Decisions</a> and key assumptions document
      </li>
      <li parentName="ol">
        <p parentName="li">{`Sizing and Entitlement Calculation Estimates.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Completive Talking Points and Key Design Points to Debunk MuleSoft`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Suggested Next Steps, Action Items and Milestones Outline`}</p>
      </li>
    </ol>
    <hr></hr>
    <h2>{`Goals`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Develop deeper skills at assessing a complex client scenario, with complex requirements, with a focus on capturing key design points, architecture decisions and deployment preparation.  `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Develop deeper skills focused on RHOCP cluster design recommendations, CP4i design, component design, workload placement recommendations and sizing recommendations.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Developer deeper skills for documenting a set of solution design artifacts which describe the proposed solution (i.e., Architecture Overview Diagram (AoD), Context Diagrams, Topology Views, Architecture Decisions document).  `}<a href="https://ibm.ent.box.com/folder/164383017863?s=kjgq175mvpr36bigr1u3u0g1558mrr43">{`Templates & Examples Can Be Found Here`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Develop deeper skills for using the IBM Sales Configurator platform, or other sizing tools, to estimate CP4i licensing entitlement.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Harvest asset examples, best practices and repeating design issues. Community Driven. `}<a href="https://ibm.box.com/s/6b2re2si75a4lqy5avxsfbg97mnlq20c">{`Place your work products here`}</a>{`.  Locate your Team Number sub-folder.`}</p>
      </li>
    </ol>
    <hr></hr>
    <h2>{`Guardrails`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Approach this exercise as if this is a `}<strong parentName="p">{`simulated client requested PoC`}</strong>{` activity.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Teams can use a `}<strong parentName="p">{`live client opportunity`}</strong>{` or PoC engagement as a source for requirements. A `}<strong parentName="p">{`fictions scenario`}</strong>{` can be provided if necessary.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`We are asking for `}<strong parentName="p">{`~8 hours`}</strong>{` of effort on this exercise; 4 hours in the Academy followed by ~4 hours  post Academy.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Submit your deliverables `}<strong parentName="p">{`5 business days`}</strong>{` after Tech Academy (`}<strong parentName="p">{`June 30`}</strong>{`).`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Five `}<strong parentName="p">{`(5) key design points`}</strong>{` are required with two `}<strong parentName="p">{`(2) optional design`}</strong>{` recommendations.`}</p>
      </li>
    </ol>
    <hr></hr>
    <h2>{`Scoring Criteria`}</h2>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "101.38888888888889%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAIF/8QAFwEAAwEAAAAAAAAAAAAAAAAAAwECBP/aAAwDAQACEAMQAAAB0lW1KwLig8UM5P/EABkQAAMBAQEAAAAAAAAAAAAAAAABAhIQQf/aAAgBAQABBQJToyjKIHyUeH//xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8BI//EABgRAQEAAwAAAAAAAAAAAAAAAAEAAhEx/9oACAECAQE/AWcncz2//8QAFhAAAwAAAAAAAAAAAAAAAAAAECBB/9oACAEBAAY/AjG//8QAHRAAAgIBBQAAAAAAAAAAAAAAAQARITEQQWGRsf/aAAgBAQABPyHfeudEFT2hmkFGgjCKUgS5On//2gAMAwEAAgADAAAAEEsXQP/EABgRAQEBAQEAAAAAAAAAAAAAAAEAMREh/9oACAEDAQE/EA8gcyMjL//EABgRAQEBAQEAAAAAAAAAAAAAAAEAIREx/9oACAECAQE/EE9irb1HV//EAB0QAQADAAMAAwAAAAAAAAAAAAERACExQVFhcaH/2gAIAQEAAT8QiLPHTE2MQoj65+2Akj7UIgm9tMbtNGwhkZxZzlh9psuCakMfF//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "scoring",
          "title": "scoring",
          "src": "/tech-academy-emea/static/a77affd5a0a50d7fde11b44c3fb4ab02/2e753/scoring-criteria.jpg",
          "srcSet": ["/tech-academy-emea/static/a77affd5a0a50d7fde11b44c3fb4ab02/69549/scoring-criteria.jpg 288w", "/tech-academy-emea/static/a77affd5a0a50d7fde11b44c3fb4ab02/473e3/scoring-criteria.jpg 576w", "/tech-academy-emea/static/a77affd5a0a50d7fde11b44c3fb4ab02/2e753/scoring-criteria.jpg 1152w", "/tech-academy-emea/static/a77affd5a0a50d7fde11b44c3fb4ab02/97583/scoring-criteria.jpg 1580w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <hr></hr>
    <h2>{`Supporting Assets`}</h2>
    <ul>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/db3lyzo87d1hnxs30n97wblsotniyvfj" target="_blank">Supporting Resources:  Architecture, Sizing, Documentation</a>
      </li>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/kjgq175mvpr36bigr1u3u0g1558mrr43" target="_blank">Sample Architecture Diagrams</a>
      </li>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/5kz0q0e33hfrlr5s9rgxlne6ixnbgd1u" target="_blank">Architecture Decisions Template</a>
      </li>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/dynuohz6d0kjtc6nrrwq69pqx5bru8bz" target="_blank">Evaluation & Scoring Outline Here.</a>
      </li>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/6b2re2si75a4lqy5avxsfbg97mnlq20c" target="_blank">Place your work products here.</a>
      </li>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/ccyfzdr0oxgibrebdz5izd9be5gu81sa" target="_blank">Fictious DoU Example</a>
      </li>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/dynuohz6d0kjtc6nrrwq69pqx5bru8bz" target="_blank">Scorecard criteria</a>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      